import "./ui.css";

interface DomainFaviconProps {
  value: string | null | undefined;
}

export function DomainFavicon({ value }: DomainFaviconProps) {
  const letter = (value?.trim()?.[0] ?? "?").toUpperCase();
  return (
    <div className="domain-favicon" aria-hidden="true">
      {letter}
    </div>
  );
}
